// extracted by mini-css-extract-plugin
module.exports = {"suspense":"suspense__3gnG0","eye":"eye__1YuoB","container":"container__ARDQM"};